import axios from '@/plugins/axios'

export default {
  index (query = '') {
    return axios.get(`/inspector/products${query}`)
  },
  details(productId) {
    return axios.get(`/inspector/products/${productId}`)
  },
}
